/**
 * Validate required environment variables
 */
export const validateEnvVariables = () => {
  const required = [
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_AUTH_DOMAIN',
    'VITE_FIREBASE_PROJECT_ID',
    'VITE_FIREBASE_APP_ID'
  ];

  const missing = required.filter(key => !import.meta.env[key]);

  if (missing.length > 0) {
    console.error('Missing environment variables:', missing);
    if (import.meta.env.PROD) {
      throw new Error('Missing required environment variables: ' + missing.join(', '));
    }
  }

  // Validate API key format
  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;
  if (apiKey && !apiKey.startsWith('AIza')) {
    console.error('Invalid Firebase API key format');
    if (import.meta.env.PROD) {
      throw new Error('Invalid Firebase API key format');
    }
  }

  console.log('Environment variables validated');
};
